import { IRequestConfig, MethodsTypes } from 'models/Axios';
import axios from 'axios';
import Services from './index.service';

export default class SellerService extends Services<any, any> {

  public async autoComplete(str: string, maxResults?: number) {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/seller`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: maxResults || 10,
        $filter: `(contains(tolower(name),'${str}') or contains(tolower(code),'${str}'))`,
      },
    };

    return await axios(config)
      .then((result) => result.data)
      .catch(() => []);
  }
}
